import script from "./ShareUser.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShareUser.vue?vue&type=script&lang=ts&setup=true"

import "./ShareUser.vue?vue&type=style&index=0&id=343e9192&lang=scss&scoped=true"

import exportComponent from "/home/deploy/www/data/workspace/ads_tencn-prod/ads/src/grow-team-assist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-343e9192"]])

export default __exports__